// Mock data for Total Vision website

export const services = [
  {
    id: 1,
    title: "Pre-Award Services",
    description: "Comprehensive feasibility studies, bid management, cost estimation, and tender documentation services to ensure successful project initiation.",
    icon: "FileText",
    image: "https://images.pexels.com/photos/3831159/pexels-photo-3831159.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Post-Award Services",
    description: "End-to-end project execution support including contract management, scheduling, coordination, and quality assurance.",
    icon: "CheckCircle",
    image: "https://images.pexels.com/photos/5257005/pexels-photo-5257005.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Engineering Services",
    description: "Multidisciplinary engineering solutions including process design, equipment design, electrical systems, piping, civil, and structural engineering.",
    icon: "Settings",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/zzvz4bso_service-engineering-oil-gas-1.jpeg"
  },
  {
    id: 4,
    title: "Construction Services",
    description: "Professional construction management, site supervision, installation oversight, and commissioning support for oil and gas projects.",
    icon: "HardHat",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/8r8oecmx_Bab%20Onshore.jpg"
  },
  {
    id: 5,
    title: "Quality Management Services",
    description: "Rigorous quality control, inspection services, NDT testing, and compliance management to ensure the highest standards.",
    icon: "Award",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/u8dkzehy_quality-management.png"
  },
  {
    id: 6,
    title: "Oil & Gas Professional's Enrichment & Mentoring",
    description: "Specialized training programs, mentoring services, and professional development for oil and gas industry personnel.",
    icon: "Users",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/g9of5zcg_meeting.jpg"
  },
  {
    id: 7,
    title: "Supply Chain Management",
    description: "Comprehensive logistics, procurement, vendor management, and supply chain optimization services for complex projects.",
    icon: "Package",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/6t9ac207_supply-chain-capabilities-slide4.png"
  }
];

export const projects = [
  {
    id: 2,
    title: "Pump Packaging Project",
    location: "UAE",
    description: "3D Modelling Services for the Pump Packaging Project including 3D Model Development for all Disciplines in PDMS software, 30%, 60%, 90% Review, Tags Clearance, GADs, ISOMETRICS & Layouts, MTO Extraction, and Close out.",
    client: "ADNOC",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/vi6uxzqt_MPP.jpg",
    year: "2025-Till Now",
    category: "3D Modelling"
  },
  {
    id: 3,
    title: "West To East Pipeline Project",
    location: "Abu Dhabi, UAE",
    description: "The objective of this Scope of Work is to define the CONSULTANT's responsibilities for the design, engineering, and supply of deliverables for nine (9) Surge Relief Valve (SRV) skids, complete with associated accessories. This Includes Detailed Engineering Services for Process Engineering, Piping Engineering, Electrical Engineering, Instrumentation & Control Engineering, and Civil & Structural Engineering.",
    client: "ADNOC",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/hmbt43dh_WEP.jpg",
    year: "2025-Till Now",
    category: "Pipeline Project"
  },
  {
    id: 8,
    title: "EPC For ASAB Phase II Project-Camp Approvals and Engineering Services",
    location: "UAE",
    description: "The EPC for Asab Phase II Project (specifically FFD-2) is a major ADNOC Onshore initiative aimed at enhancing oil production and processing capabilities, including upgrading RDS 1-6, installing new gas lift trains, and replacing flowlines. The scope involves detailed engineering, procurement, construction, and pre-commissioning. Key aspects include temporary camp, office, and amenity construction for workforce housing, alongside specialized engineering services for hazardous area electrical, civil, and pipeline works.",
    client: "ADNOC",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/kbyqktj1_ASAB.jpg",
    year: "2022-2023",
    category: "EPC Project"
  },
  {
    id: 4,
    title: "EPCM For Fujairah BC Project - ADNOC Onshore",
    location: "UAE",
    description: "The project involved crucial brownfield rehabilitation to enhance MOT Fujairah facilities. This includes Detailed Engineering Services for Process Engineering, Piping Engineering, Mechanical Engineering, Electrical Engineering, Instrumentation & Control Engineering, HVAC Engineering, Telecom Engineering, Civil & Structural Engineering, and Technical Safety (HSE) Engineering.",
    client: "ADNOC",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/qd93i2ho_ADNOC-Onshore.jpg",
    year: "2023-2024",
    category: "EPCM Project"
  },
  {
    id: 5,
    title: "Buhasa Tie-Ins (2021-2025) Package 1(P12516) ADNOC Onshore",
    location: "Abu Dhabi, UAE",
    description: "This involves EPC services to connect newly drilled smart wells to main production facilities in the Bu Hasa field. Detailed Engineering Services for Well Tie-ins which includes Process Engineering, Piping Engineering, Pipeline Engineering, Mechanical Engineering, Electrical Engineering, Instrumentation & Control Engineering, and Civil & Structural Engineering.",
    client: "ADNOC",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/08dpscyk_BU%20Hasa.jpg",
    year: "2022-2024",
    category: "EPC Project"
  },
  {
    id: 6,
    title: "Rumaila Oil Field Development",
    location: "Basra, Iraq",
    description: "World's third biggest producing field at 1.5 million barrels per day, delivering approximately one-third of Iraq's total oil supply. Operating since 1954 with 17 billion barrels of recoverable reserves.",
    client: "BP",
    image: "https://images.pexels.com/photos/15961091/pexels-photo-15961091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2019-2023",
    category: "Oil Field Development"
  },
  {
    id: 7,
    title: "Tawke Oil Field",
    location: "Duhok Province, Kurdistan Region",
    description: "Oil field development in northern Kurdistan Region with recent completion of Peshkabir-9 and Tawke-52 wells, including exploration targeting Cretaceous reservoir.",
    client: "DNO",
    image: "https://images.pexels.com/photos/10407684/pexels-photo-10407684.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2018-2023",
    category: "Oil Field Development"
  },
  {
    id: 9,
    title: "Al Halfaya Oil Field Development",
    location: "Maysan Province, Iraq",
    description: "One of the biggest oil fields in Iraq, located 35km south-east of Amara. Operated by PetroChina with partners including Total, Petronas Carigali, and South Oil Company.",
    client: "PetroChina / CNPC",
    image: "https://images.pexels.com/photos/9336586/pexels-photo-9336586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2018-2022",
    category: "Oil Field Development"
  },
  {
    id: 10,
    title: "West Qurna Phase 2 Development",
    location: "Basra, Iraq",
    description: "One of the world's biggest onshore oilfields. Owned and operated by Lukoil (75%) and North Oil Company (25%). Production reached 100 million tonnes as of 2019.",
    client: "Lukoil",
    image: "https://images.pexels.com/photos/15970023/pexels-photo-15970023.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2017-2021",
    category: "Oil & Gas Field"
  },
  {
    id: 11,
    title: "Mombasa-Nairobi Pipeline Inspection",
    location: "Kenya",
    description: "In-Line Inspection (ILI) and Material Grade Determination (MGD) for 20-inch, 450km pipeline from Mombasa to Nairobi. Commissioned in 2018.",
    client: "Kenya Pipeline Company",
    image: "https://images.pexels.com/photos/18784617/pexels-photo-18784617.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    year: "2018-2020",
    category: "Pipeline Services"
  }
];

export const clients = [
  {
    id: 1,
    name: "CNPC",
    logo: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/onw660sd_CNPC.jpg"
  },
  {
    id: 2,
    name: "BP",
    logo: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/d6agaf0w_BP-logo.jpg"
  },
  {
    id: 3,
    name: "Total Energies",
    logo: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/sysa72oh_totalenergies_1.png"
  },
  {
    id: 4,
    name: "ADNOC",
    logo: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/dzuzl4cc_ADNOC.jpg"
  },
  {
    id: 5,
    name: "Robt-Stone (ME)-LLC OPC",
    logo: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/rfzedu0s_Robtstone.png"
  },
  {
    id: 6,
    name: "Alucor Construction LLC",
    logo: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/5wx3vnrg_Alucor.jpg"
  }
];

export const news = [
  {
    id: 1,
    category: "Project Award",
    title: "ADNOC Onshore Awards $920M AI-Powered Well Digitalization Program",
    description: "ADNOC Onshore awarded a major contract for AI-powered well digitalization program covering over 2,000 wells across Bab, Bu Hasa, and Southeast fields. The initiative leverages private 5G network technology for real-time data analytics, predictive maintenance, and autonomous control, targeting completion by 2027 to enhance efficiency and reduce emissions.",
    date: "November 2024",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/zzvz4bso_service-engineering-oil-gas-1.jpeg"
  },
  {
    id: 2,
    category: "Infrastructure",
    title: "ADNOC Gas Launches $5B Rich Gas Development Project Phase 1",
    description: "ADNOC Gas announced FID for Phase 1 of its $5 billion Rich Gas Development project, optimizing onshore facilities at Asab, Bu Hasa, and Habshan. The project involves major EPC contracts to expand gas processing capacity and support UAE's gas self-sufficiency goals, with engineering services spanning multiple disciplines.",
    date: "2024",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/kbyqktj1_ASAB.jpg"
  },
  {
    id: 3,
    category: "Engineering Excellence",
    title: "Ongoing Engineering Services for Major UAE Oil & Gas Projects",
    description: "Total Vision continues to deliver comprehensive engineering services across multiple ADNOC Onshore projects including Bab Upgrades, Buhasa Tie-Ins, ASAB Phase II, and West To East Pipeline initiatives. The company's multidisciplinary expertise spans process, piping, mechanical, electrical, instrumentation, civil, and structural engineering disciplines.",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_precision-vision/artifacts/8r8oecmx_Bab%20Onshore.jpg"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Engineering Excellence",
    role: "Our Expert Team",
    description: "Highly qualified professionals with decades of combined experience in oil & gas sector.",
    image: "https://images.pexels.com/photos/3831159/pexels-photo-3831159.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    name: "Quality Assurance",
    role: "Dedicated Specialists",
    description: "Committed to maintaining the highest standards in every project we undertake.",
    image: "https://images.pexels.com/photos/3862614/pexels-photo-3862614.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const stats = [
  {
    id: 1,
    number: "20+",
    label: "Years Experience",
    icon: "Calendar"
  },
  {
    id: 2,
    number: "50+",
    label: "Projects Completed",
    icon: "Briefcase"
  },
  {
    id: 3,
    number: "15+",
    label: "Countries Served",
    icon: "Globe"
  },
  {
    id: 4,
    number: "100+",
    label: "Expert Professionals",
    icon: "Users"
  }
];